import AppSetting from '../../common/constants/appsetting.constant';
import StorageType from '../session/storage.enum';
import StorageService from '../session/storage.service';
import axios from 'axios'

const AuditLogsService = {
  getLoggedInData() {
    return JSON.parse(StorageService.get(StorageType.session, 'userDetails'));
  },

  getAuditLogs(params) {
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.settings.getAllAuditLogs
      .replace('{providerId}', loggedInUserData.parentId)
      + this.buildQuery(params);
    return axios.get(url)
      .then(a => { return a })
      .catch(err => {return err})
  },
  getAuditById(auditLogId) {
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.settings.getAuditLogById
      .replace('{providerId}', loggedInUserData.parentId)
      .replace('{auditLogId}', auditLogId)
    return axios.get(url)
      .then(a => { return a })
      .catch(err => {return err})
  },

  buildQuery(data) {
    let queryData = '';
    for (const prop in data) {
      if (data[prop] !== '' && data[prop] !== 'undefined' && data[prop] !== null) {
        if (queryData === '') {
          queryData = '?' + prop + '=' + data[prop];
        } else {
          queryData += '&' + prop + '=' + data[prop];
        }
      }
    } return queryData;
  },
}

export default AuditLogsService